$(document).ready(function () {
  $(".pro_selection_text_col select.select_varint").on("change", function () {
    if ($(this).val()) {
      $(".pro_add_to_cart").text("Add To Cart");
      $(".pro_add_to_cart").addClass("pro_add_to_cart_active");
    }
  });

  function reload_cart_drawer() {
    fetch(window.Shopify.routes.root + "?section_id=cart-drawer")
      .then((responseText) => responseText.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        var html_drawer = $(html).find(".cc-popup-content");
        var html_drawer_quntity = $(html).find(".cart-link");
        $(".cc-popup-content").html(html_drawer);
        $(".cart-link").click();
        var total_quntity = $(".cart-item-list__body").attr("item-total");
        $(".cart-link__icon").append(
          '<span class="cart-link__count">' + total_quntity + "</span>"
        );
        $(".cart-link__count").text(total_quntity);
        $(".pro_add_to_cart_active").css({
          "background-color": "#fc46aa",
          "border-color": "#fc46aa",
        });
        $(".pro_add_to_cart_active").html("Add To Cart");
      });
  }

  $(document).on("click", ".pro_add_to_cart", function (e) {
    if (
      $(".pro_selection_option_variant .cart_active").length !=
      $(".pro_selection_option_variant").data("val")
    ) {
      alert("Please Select Product Variant");
    }
  });

  $(document).on("click", ".pro_add_to_cart_active", function (e) {
    e.preventDefault();

    var id = $(this).attr("value");
    var quantity = 1;

    let formData = {
      items: [
        {
          id: id,
          quantity: quantity,
        },
      ],
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        $(".pro_add_to_cart_active").css({
          "background-color": "#999",
          "border-color": "#999",
        });
        $(".pro_add_to_cart_active").html(
          '<div class="loading-spinner loading-spinner--in-btn"></div>'
        );

        reload_cart_drawer();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });

  // TAB CONTENT
  $(".tab_title_wrap ul.tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");
    $(".tab_title_wrap ul.tabs li").removeClass("current");
    $(".tab_content_wrap .tab-content").removeClass("current");
    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  $(".search_btn").click(function (event) {
    event.preventDefault();
    $(this).next(".show-gallery").click();
  });

  $(".product-slideshow .rimage-wrapper").click(function (event) {
    event.preventDefault();
    return false;
  });

  //   $('.quantity-submit-row__submit .button').text('Select Size')
  //   $('.option-selector .opt-btn').on('click', function() {
  //   $('.quantity-submit-row__submit .button').text('Select Size');
  //     console.log('fddf');
  //     $(this).parents('.option-selector').addClass('pro_cart_active');
  //     console.log($('.option-selectors .pro_cart_active').length);
  //     console.log($('.option-selectors').data('value'));

  //     if ($('.option-selectors .pro_cart_active').length == $('.option-selectors').data('value')){
  //           $('.quantity-submit-row__submit .button').text('Add To Cart')
  //     }else{
  //             $('.quantity-submit-row__submit .button').text('Select Size');
  //     }
  // });

  setInterval(function () {
    if ($(".original-selector").val() != "") {
      $(".quantity-submit-row__submit .button:not(:disabled)").text(
        "Add to Cart"
      );
    }
  }, 10);

  if ($(window).width() >= 1041) {
    $(".thumbnails").slick({
      vertical: true,
      verticalSwiping: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: false,
      prevArrow:
        '<button type="button" class="slick-prev pull-left"><svg xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="800px" width="800px" version="1.1" id="Layer_1" viewBox="0 0 330 330" xml:space="preserve" style="transform: rotate(180deg);"><path id="XMLID_225_" d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393  c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393  s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z" style="&#10;"/></svg></button>',
      nextArrow:
        '<button type="button" class="slick-next pull-right"><svg xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="800px" width="800px" version="1.1" id="Layer_1" viewBox="0 0 330 330" xml:space="preserve"><path id="XMLID_225_" d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393  c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393  s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"/></svg></button>',
    });
  }

  setInterval(function(){
    if($(".thumbnail.slick-current").length){
      $(".thumbnail").removeClass("selected");
      $(".thumbnail.slick-current").addClass("selected");
    }
  }, 100);
});
